import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {Country, CountryQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const COUNTRIES_URL = `${API_URL}/country`
// const GET_COUNTRIES_URL = `${API_URL}/user`

const getCountries = (query: string): Promise<CountryQueryResponse> => {
  return axios
    .get(`${COUNTRIES_URL}?${query}`)
    .then((d: AxiosResponse<CountryQueryResponse>) => d.data)
}

const getCountryById = (id: ID,query?: string): Promise<Country | undefined> => {
  return axios
    .get(`${COUNTRIES_URL}/${id}?${query}`)
    .then((response: AxiosResponse<Response<Country>>) => response.data)
    .then((response: Response<Country>) => response.data)
}

const createCountry = (model: Country): Promise<CountryQueryResponse | undefined> => {
  return axios
    .post(COUNTRIES_URL, model)
    .then((response: AxiosResponse<CountryQueryResponse>) => response.data)
    .then((response: CountryQueryResponse) => response)
}

const updateCountry = (model: Country): Promise<CountryQueryResponse> => {
  return axios
    .post(`${COUNTRIES_URL}/${model.id}`, model)
    .then((response: AxiosResponse<CountryQueryResponse>) => response.data)
    .then((response: CountryQueryResponse) => response)
}

const deleteCountry = (modelId: ID): Promise<CountryQueryResponse | undefined> => {
  return axios
  .delete(`${COUNTRIES_URL}/${modelId}`)
  .then((response: AxiosResponse<CountryQueryResponse>) => response.data)
  .then((response: CountryQueryResponse) => response)
}

const deleteSelectedCountries = (modelIds: Array<ID>): Promise<void> => {
  const requests = modelIds.map((id) => axios.delete(`${COUNTRIES_URL}/${id}`))
  return axios.all(requests).then(() => {})
}
export {getCountries,getCountryById,createCountry,updateCountry,deleteCountry,deleteSelectedCountries}
